import * as React from 'react';

import NavigationArrowUpIcon from '../../../assets/icons/v2design/navigation/arrow-up.svg';
import NavigationArrowDownIcon from '../../../assets/icons/v2design/navigation/arrow-down.svg';
import NavigationArrowRightIcon from '../../../assets/icons/v2design/navigation/arrow-right.svg';
import NavigationArrowLeftIcon from '../../../assets/icons/v2design/navigation/arrow-left.svg';
import NavigationChevronLeftIcon from '../../../assets/icons/v2design/navigation/chevron-left.svg';
import NavigationChevronRightIcon from '../../../assets/icons/v2design/navigation/chevron-right.svg';
import NavigationChevronUpIcon from '../../../assets/icons/v2design/navigation/chevron-up.svg';
import NavigationChevronDownIcon from '../../../assets/icons/v2design/navigation/chevron-down.svg';

import TypeTextIcon from '../../../assets/icons/v2design/type/text.svg';
import TypeBoldIcon from '../../../assets/icons/v2design/type/bold.svg';
import TypeItalicIcon from '../../../assets/icons/v2design/type/italics.svg';
import TypeBulletListIcon from '../../../assets/icons/v2design/type/bullet-list.svg';
import TypeNumberListIcon from '../../../assets/icons/v2design/type/number-list.svg';
import TypeListIcon from '../../../assets/icons/v2design/type/list.svg';
import TypeAlignLeftIcon from '../../../assets/icons/v2design/type/align-left.svg';
import TypeAlignCenterIcon from '../../../assets/icons/v2design/type/align-center.svg';
import TypeAlignRightIcon from '../../../assets/icons/v2design/type/align-right.svg';
import TypeAlignJustifyIcon from '../../../assets/icons/v2design/type/align-justify.svg';

import BasicsMenuVerticalIcon from '../../../assets/icons/v2design/basics/menu-vertical.svg';
import BasicsMenuHorizontalIcon from '../../../assets/icons/v2design/basics/menu-horizontal.svg';
import BasicsCopyIcon from '../../../assets/icons/v2design/basics/copy.svg';
import BasicsPasteIcon from '../../../assets/icons/v2design/basics/paste.svg';
import BasicsEditIcon from '../../../assets/icons/v2design/basics/edit.svg';
import BasicsInfoIcon from '../../../assets/icons/v2design/basics/info.svg';
import BasicsAlertIcon from '../../../assets/icons/v2design/basics/alert.svg';
import BasicsDragIcon from '../../../assets/icons/v2design/basics/drag.svg';
import BasicsCloseIcon from '../../../assets/icons/v2design/basics/close.svg';
import BasicsAddIcon from '../../../assets/icons/v2design/basics/add.svg';
import BasicsMinusIcon from '../../../assets/icons/v2design/basics/minus.svg';
import BasicsSearchIcon from '../../../assets/icons/v2design/basics/search.svg';
import BasicsStyleIcon from '../../../assets/icons/v2design/basics/style.svg';
import BasicsHelpIcon from '../../../assets/icons/v2design/basics/help.svg';
import BasicsLockIcon from '../../../assets/icons/v2design/basics/lock.svg';
import BasicsQuoteIcon from '../../../assets/icons/v2design/basics/quote.svg';
import BasicsTrashIcon from '../../../assets/icons/v2design/basics/trash.svg';
import BasicsCheckIcon from '../../../assets/icons/v2design/basics/check.svg';
import BasicsGridIcon from '../../../assets/icons/v2design/basics/grid.svg';
import BasicsShareIcon from '../../../assets/icons/v2design/basics/share.svg';
import BasicsShowIcon from '../../../assets/icons/v2design/basics/show.svg';
import BasicsRefreshIcon from '../../../assets/icons/v2design/basics/refresh.svg';
import BasicsImageIcon from '../../../assets/icons/v2design/basics/image.svg';
import BasicsExpandIcon from '../../../assets/icons/v2design/basics/expand.svg';
import BasicsCalendarIcon from '../../../assets/icons/v2design/basics/calendar.svg';
import BasicsResetIcon from '../../../assets/icons/v2design/basics/reset.svg';
import BasicsUploadIcon from '../../../assets/icons/v2design/basics/upload.svg';
import BasicsSortIcon from '../../../assets/icons/v2design/basics/sort.svg';
import BasicsLabelIcon from '../../../assets/icons/v2design/basics/label.svg';
import BasicsNetworkGlobalIcon from '../../../assets/icons/v2design/basics/network-global.svg';
import BasicsNotificationIcon from '../../../assets/icons/v2design/basics/notification.svg';
import BasicsUserIcon from '../../../assets/icons/v2design/basics/user.svg';
import BasicsTeamIcon from '../../../assets/icons/v2design/basics/team.svg';
import BasicsInviteIcon from '../../../assets/icons/v2design/basics/invite.svg';
import BasicsInviteRemoveIcon from '../../../assets/icons/v2design/basics/remove.svg';
import BasicsEmailIcon from '../../../assets/icons/v2design/basics/email.svg';
import BasicsTimeIcon from '../../../assets/icons/v2design/basics/time.svg';
import BasicsSettingsIcon from '../../../assets/icons/v2design/basics/settings.svg';
import BasicsVideoIcon from '../../../assets/icons/v2design/basics/video.svg';
import BasicsFilterIcon from '../../../assets/icons/v2design/basics/filter.svg';
import BasicsExternalLinkIcon from '../../../assets/icons/v2design/basics/external-link.svg';
import BasicsFormIcon from '../../../assets/icons/v2design/basics/form.svg';
import BasicsLongTextIcon from '../../../assets/icons/v2design/basics/long-text.svg';
import BasicsSizeIcon from '../../../assets/icons/v2design/basics/size.svg';
import BasicsUpgradeIcon from '../../../assets/icons/v2design/basics/upgrade.svg';
import BasicsSaveIcon from '../../../assets/icons/v2design/basics/save.svg';
import BasicsLayoutIcon from '../../../assets/icons/v2design/basics/layout.svg';
import BasicsMediaIcon from '../../../assets/icons/v2design/basics/media.svg';
import BasicsColorIcon from '../../../assets/icons/v2design/basics/color.svg';
import BasicsBadgeIcon from '../../../assets/icons/v2design/basics/badge.svg';
import BasicsUndoIcon from '../../../assets/icons/v2design/basics/undo.svg';
import BasicsRedoIcon from '../../../assets/icons/v2design/basics/redo.svg';
import BasicsSectionIcon from '../../../assets/icons/v2design/basics/section.svg';
import BasicsPostIcon from '../../../assets/icons/v2design/basics/post.svg';
import BasicsPageIcon from '../../../assets/icons/v2design/basics/page.svg';
import BasicsLogoutIcon from '../../../assets/icons/v2design/basics/logout.svg';
import BasicsIntegrationIcon from '../../../assets/icons/v2design/basics/integration.svg';
import BasicsHamburgerIcon from '../../../assets/icons/v2design/basics/hamburger.svg';
import BasicsLinkIcon from '../../../assets/icons/v2design/basics/link.svg';
import BasicsBreadcrumbsIcon from '../../../assets/icons/v2design/basics/breadcrumbs.svg';
import BasicsCodeIcon from '../../../assets/icons/v2design/basics/code.svg';
import BasicsCmsIcon from '../../../assets/icons/v2design/basics/cms.svg';
import BasicsCollapseIcon from '../../../assets/icons/v2design/basics/collapse.svg';
import BasicsCreditCardIcon from '../../../assets/icons/v2design/basics/credit-card.svg';
import BasicsPinIcon from '../../../assets/icons/v2design/basics/pin.svg';
import BasicsStarIcon from '../../../assets/icons/v2design/basics/star.svg';
import BasicsStarFullIcon from '../../../assets/icons/v2design/basics/star-full.svg';
import BasicsSparklesIcon from '../../../assets/icons/v2design/basics/sparkles.svg';
import BasicsSparklesFullIcon from '../../../assets/icons/v2design/basics/sparkles-full.svg';

import PanelsContentIcon from '../../../assets/icons/v2design/panels/content.svg';
import PanelsSeoIcon from '../../../assets/icons/v2design/panels/seo.svg';

export const MAP = {
    'arrow-up': NavigationArrowUpIcon,
    'arrow-down': NavigationArrowDownIcon,
    'arrow-left': NavigationArrowLeftIcon,
    'arrow-right': NavigationArrowRightIcon,
    'chevron-left': NavigationChevronLeftIcon,
    'chevron-right': NavigationChevronRightIcon,
    'chevron-up': NavigationChevronUpIcon,
    'chevron-down': NavigationChevronDownIcon,

    text: TypeTextIcon,
    bold: TypeBoldIcon,
    italic: TypeItalicIcon,
    list: TypeBulletListIcon,
    'list-ol': TypeNumberListIcon,
    'list-check': TypeListIcon,
    'align-left': TypeAlignLeftIcon,
    'align-center': TypeAlignCenterIcon,
    'align-right': TypeAlignRightIcon,
    'align-justify': TypeAlignJustifyIcon,

    'ellipsis-vertical': BasicsMenuVerticalIcon,
    ellipsis: BasicsMenuHorizontalIcon,
    copy: BasicsCopyIcon,
    paste: BasicsPasteIcon,
    pencil: BasicsEditIcon,
    'circle-info': BasicsInfoIcon,
    'circle-exclamation': BasicsAlertIcon,
    'grid-dots-vertical': BasicsDragIcon,
    xmark: BasicsCloseIcon,
    plus: BasicsAddIcon,
    minus: BasicsMinusIcon,
    'magnifying-glass': BasicsSearchIcon,
    palette: BasicsStyleIcon,
    'circle-question': BasicsHelpIcon,
    lock: BasicsLockIcon,
    'comment-quote': BasicsQuoteIcon,
    trash: BasicsTrashIcon,
    check: BasicsCheckIcon,
    'grid-2': BasicsGridIcon,
    'arrow-up-from-square': BasicsShareIcon,
    eye: BasicsShowIcon,
    'arrows-rotate': BasicsRefreshIcon,
    image: BasicsImageIcon,
    'up-right-and-down-left-from-center': BasicsExpandIcon,
    calendar: BasicsCalendarIcon,
    'arrow-rotate-right': BasicsResetIcon,
    'arrow-up-from-bracket': BasicsUploadIcon,
    'arrow-down-arrow-up': BasicsSortIcon,
    flag: BasicsLabelIcon,
    globe: BasicsNetworkGlobalIcon,
    bell: BasicsNotificationIcon,
    user: BasicsUserIcon,
    users: BasicsTeamIcon,
    'user-plus': BasicsInviteIcon,
    'user-minus': BasicsInviteRemoveIcon,
    envelope: BasicsEmailIcon,
    clock: BasicsTimeIcon,
    gear: BasicsSettingsIcon,
    'camera-movie': BasicsVideoIcon,
    filter: BasicsFilterIcon,
    'arrow-up-right-from-square': BasicsExternalLinkIcon,
    memo: BasicsFormIcon,
    'long-text': BasicsLongTextIcon,
    'screen-size': BasicsSizeIcon,
    gem: BasicsUpgradeIcon,
    bookmark: BasicsSaveIcon,
    'table-list': BasicsLayoutIcon,
    paperclip: BasicsMediaIcon,
    'fill-drip': BasicsColorIcon,
    badge: BasicsBadgeIcon,
    undo: BasicsUndoIcon,
    redo: BasicsRedoIcon,
    section: BasicsSectionIcon,
    post: BasicsPostIcon,
    page: BasicsPageIcon,
    'arrow-left-from-bracket': BasicsLogoutIcon,
    integration: BasicsIntegrationIcon,
    bars: BasicsHamburgerIcon,
    link: BasicsLinkIcon,
    'list-tree': BasicsBreadcrumbsIcon,
    code: BasicsCodeIcon,
    'layer-group': BasicsCmsIcon,
    'angles-right': BasicsCollapseIcon,
    'credit-card': BasicsCreditCardIcon,
    thumbtack: BasicsPinIcon,
    star: BasicsStarIcon,
    'star-full': BasicsStarFullIcon,
    sparkles: BasicsSparklesIcon,
    'sparkles-full': BasicsSparklesFullIcon,

    layout: PanelsContentIcon,
    'chart-arrow-up-right': PanelsSeoIcon
} as const;

export type DynamicIcon = keyof typeof MAP;

type Props = {
    className?: string;
    icon: DynamicIcon;
};

const DynamicIconView = (props: Props) => {
    const Icon = MAP[props.icon];
    return <Icon className={props.className} />;
};

type SafeProps = Omit<Props, 'icon'> & {
    icon: string;
};

export const SafeDynamicIconView = (props: SafeProps) => {
    if (!MAP[props.icon as DynamicIcon]) {
        return null;
    }
    return <DynamicIconView {...props} icon={props.icon as DynamicIcon} />;
};

type RandomProps = Omit<Props, 'icon'>;

export const RandomIconView = (props: RandomProps) => {
    const icons = Object.keys(MAP);
    const iconIndex = Math.floor(Math.random() * icons.length);
    const icon = icons[iconIndex]!;
    return <SafeDynamicIconView {...props} icon={icon} />;
};

export default DynamicIconView;
